import Stack from '@liquidweb-dev/undercurrent/Stack';
import HistoryIcon from '@liquidweb-dev/undercurrent/icons/lucide/History';
import RefreshCcwIcon from '@liquidweb-dev/undercurrent/icons/lucide/RefreshCcw';
import SparklesIcon from '@liquidweb-dev/undercurrent/icons/lucide/Sparkles';
import SquareTerminalIcon from '@liquidweb-dev/undercurrent/icons/lucide/SquareTerminal';
import Button from '@liquidweb-dev/undercurrent/Button';
import HelpDocCard from './HelpDocCard';

const CloudBareMetalServerDetails = () => {
	return (
		<Stack gap={200}>
			<HelpDocCard
				title="Getting Started with Bare Metal"
				description="Set up and explore your Bare Metal server essentials"
				icon={SparklesIcon}
				link="https://www.liquidweb.com/help-docs/getting-started-with-your-bare-metal-server/"
			/>
			<HelpDocCard
				title="Bare Metal backup solutions"
				description="Review options to back up and protect your server data"
				icon={HistoryIcon}
				link="https://www.liquidweb.com/help-docs/hosting-service/bare-metal-servers/bare-metal-server-backups/"
			/>
			<HelpDocCard
				title="Reimage your server"
				description="Wipe and restore your server to a clean state"
				icon={RefreshCcwIcon}
				link="https://www.liquidweb.com/help-docs/reimage-a-bare-metal-server/"
			/>
			<HelpDocCard
				title="Console Access"
				description="Connect to your server directly through our console"
				icon={SquareTerminalIcon}
				link="https://www.liquidweb.com/help-docs/hosting-service/dedicated-servers/accessing-your-server-from-the-liquid-web-console/"
			/>
			<Button
				variant="ghost"
				size="large"
				sx={() => ({ paddingY: 100 })}
				onClick={() =>
					window.open(
						'https://www.liquidweb.com/help-docs/hosting-service/bare-metal-servers/',
						'_blank',
					)
				}
			>
				See all Bare Metal Docs
			</Button>
		</Stack>
	);
};

export default CloudBareMetalServerDetails;
